import { useDispatch } from 'react-redux';
import { AppDispatch } from '../app-types';

export const useAppDispatch = () => useDispatch<AppDispatch>();
